module.exports = __webpack_public_path__ + "img/PPMPRA9.669dd9b8.png";